import moment from "moment/moment";
import { getAutopayFrequencyDate } from "js/utilities/getAutopayFrequencyDate";
import { getAutoPayDescriptions } from "js/formatting/getAutoPayDescriptions";
import { getPolicyQuote } from "service/policy/getPolicyQuote";
import { sendSmsMessage } from "service/notificationservice/sendSmsMessage";
import { getAllOwnersFromParties } from "js/utilities";
import { RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import {
  convertToTitleCase,
  getDraftDayDisclaimer,
  getName,
  getNextPaymentDate,
  getPolicyType,
  stringFormattingToCurrency,
} from "js/formatting";

import UpdatePaymentFrequency from "service/paymentServices/UpdatePaymentFrequency";
import getPaymentProfileApi from "service/paymentServices/GetPaymentProfile/index";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import setUpPolicyAutoPayApi from "service/paymentServices/AddPaymentAutopay";
import GeneralPurposeDialog from "components/General/GeneralPurposeDialog";
import AddPaymentMethod from "components/ModalDialogs/AddPaymentMethod";
import useTrackManageAutoPay from "logging/hooks/useTrackManageAutoPay";
import PaymentDialog from "components/Profile/Dialogs/PaymentDialog";
import Toast from "components/General/Toast";
import Tooltip from "components/General/Tooltip";
import config from "config/config";

export default function EditManageAutoPay({
  selectedPolicy,
  setManageAutoPayMode,
}) {
  let navigate = useNavigate();
  let trackManageAutoPay = useTrackManageAutoPay();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector((state) => state.user);
  const { csrUser } = useSelector((s) => s.csrUser);

  const { register, handleSubmit, getValues, setValue } = useForm({
    defaultValues: {
      billingmode: selectedPolicy?.billingMode?.toLowerCase(),
    },
  });
  const [nextPayment, setNextPayment] = useState();
  const [dateOfFrequency, setDateOfFrequency] = useState();
  const [cardNumbers, setCardNumbers] = useState([]);
  const [selected, setSelected] = useState();
  const [data, setData] = useState();
  const [frequency, setFrequency] = useState([]);
  const [ccQuotes, SetCCQuotes] = useState([]);

  const [paymentProfile, setPaymentProfile] = useState([]);
  const [agrementState, setAgrementState] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [confirmation, setConfirmation] = useState();
  const [referenceNumber, setReferenceNumber] = useState();
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [csrUserState, setCsrUserState] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [party, setParty] = useState("");
  const [toastDetail, setToastDetail] = useState({
    type: undefined,
    title: "",
    message: "",
  });

  const owners = getAllOwnersFromParties(selectedPolicy.parties);
  const loggedUser = owners?.find(
    (x) => x.person?.taxId === user.identityNumber
  );

  const errorOccurred = (title, message) => {
    setIsContinueDisabled(true);
    setToastDetail({
      type: "error",
      title: title,
      message: message,
    });
  };
  function getDistinctPaymentProfile(paymentProfiles) {
    let paymentProfileList = [];
    paymentProfiles.forEach((paymentProfile) => {
      if (paymentProfileList?.length === 0) {
        paymentProfileList.push(paymentProfile);
      } else {
        let exstingPaymentProfile = paymentProfileList.find(
          (c) => c.cardNumber === paymentProfile.cardNumber
        );
        if (!exstingPaymentProfile) {
          paymentProfileList.push(paymentProfile);
        }
      }
    });
    return paymentProfileList;
  }

  useEffect(() => {
    function getPaymentProfile() {
      if (!selectedPolicy)
        return errorOccurred(
          t("AuthCustomerEditAutoPay-errorTitle"),
          t("AuthCustomerEditAutoPay-errorMessage")
        );

      setIsLoading(true);
      if (selectedPolicy) {
        // get autopay cards for login user
        getPaymentProfileApi({
          policies: [selectedPolicy],
          UserId: user?.userId,
        })
          .then((response) => {
            if (response?.length > 0) {
              response?.forEach((profile) => {
                if (
                  profile?.userId !== user?.userId &&
                  profile?.paymentProfileId ===
                    selectedPolicy?.creditCard?.recurringReferenceId
                ) {
                  setParty(profile);
                  setShowTooltip(true);
                }
              });
              let paymentProfiles = getDistinctPaymentProfile(response);
              setPaymentProfile(paymentProfiles);
              let cards = paymentProfiles.map((p) => p.cardNumber);
              if (cards?.length > 0) {
                setCardNumbers(cards);
                let selectedProfile = paymentProfiles.find(
                  (profile) =>
                    profile.recurringReferenceId ===
                    selectedPolicy?.creditCard?.recurringReferenceId
                );
                if (selectedProfile?.cardNumber) {
                  setValue("cardNumber", selectedProfile?.cardNumber);
                  setSelected(selectedProfile?.cardNumber);
                } else {
                  setValue("cardNumber", cards[0]);
                  setSelected(cards[0]);
                }
              }
            }

            if (selectedPolicy?.billingTypeCode === "02") {
              // EFT Auto pay
              let accountNumber = selectedPolicy?.bankInfo?.bank?.accountNumber;

              let fourDigitAccountNumber = accountNumber?.substring(
                accountNumber.length - 4
              );
              if (response?.length)
                setCardNumbers((current) => [
                  fourDigitAccountNumber,
                  ...current,
                ]);
              else setCardNumbers([fourDigitAccountNumber]);
              setValue("cardNumber", fourDigitAccountNumber);
              setSelected(fourDigitAccountNumber);
            }

            if (!selectedPolicy?.billingMode)
              setValue("billingmode", "monthly");
          })
          .catch((error) => {
            console.error(
              "Server refused to connect, please try again later.",
              error
            );
            errorOccurred(
              t("AuthCustomerEditAutoPay-errorTitle"),
              t("AuthCustomerEditAutoPay-errorMessage")
            );
          });
      }

      if (selectedPolicy?.contractID) {
        // get policy Quote for monthly, annual, semi-annual and quarterly
        getPolicyQuote(selectedPolicy?.contractID)
          .then((response) => {
            const billingType =
              selectedPolicy.billingTypeCode === "06"
                ? "credit card"
                : selectedPolicy.billingTypeCode === "02"
                ? "eft"
                : "";
            const creditCardquotes = response.filter(
              (quoteDetail) =>
                quoteDetail?.billingType?.toLowerCase() === billingType
            );
            if (creditCardquotes) {
              SetCCQuotes(creditCardquotes);
              setFrequency([
                {
                  title: `Monthly (${
                    creditCardquotes.find(
                      (creditCardquote) =>
                        creditCardquote?.billingMode?.toLowerCase() ===
                        "monthly"
                    ).totalModalPremiumAmount
                  })`,
                  value: "monthly",
                },
                {
                  title: `Quarterly (${
                    creditCardquotes.find(
                      (creditCardquote) =>
                        creditCardquote?.billingMode?.toLowerCase() ===
                        "quarterly"
                    ).totalModalPremiumAmount
                  })`,
                  value: "quarterly",
                },
                {
                  title: `Semi-Annually (${
                    creditCardquotes.find(
                      (creditCardquote) =>
                        creditCardquote?.billingMode?.toLowerCase() ===
                        "semi-annual"
                    ).totalModalPremiumAmount
                  })`,
                  value: "semi-annual",
                },
                {
                  title: `Annually (${
                    creditCardquotes.find(
                      (creditCardquote) =>
                        creditCardquote?.billingMode?.toLowerCase() === "annual"
                    ).totalModalPremiumAmount
                  })`,
                  value: "annual",
                },
              ]);
              setIsLoading(false);
              setDateOfFrequency(moment(selectedPolicy?.paidThroughDate));
              setNextPayment(
                getNextPaymentDate(
                  selectedPolicy?.billingMode?.toLowerCase(),
                  selectedPolicy?.paidThroughDate
                )
              );
            } else {
              console.error("getPolicyQuote returns.", response);
              setIsLoading(false);
            }
          })
          .catch((error) => {
            console.error(
              "Server refused to connect, please try again later.",
              error
            );
            errorOccurred(
              t("AuthCustomerManageAutoPay-errorTitle"),
              t("AuthCustomerManageAutoPay-errorMessage")
            );
            setIsLoading(false);
          });
      }
    }
    getPaymentProfile();
  }, [selectedPolicy]);

  const getExistingCreditCard = () => {
    if (selectedPolicy?.billingTypeCode === "06") {
      let pProfile = paymentProfile?.find(
        (profile) =>
          profile?.paymentProfileId ===
          selectedPolicy?.creditCard?.recurringReferenceId
      );

      return pProfile?.cardNumber;
    } else if (selectedPolicy?.billingTypeCode === "02") {
      let accountNumber = selectedPolicy?.bankInfo?.bank?.accountNumber;

      return accountNumber?.substring(accountNumber.length - 4);
    }
    return "";
  };

  const openAgrementForm = (data) => {
    setAgrementState(true);
    setData({
      REPLACE_POLICY_ID: selectedPolicy?.contractID,
      REPLACE_POLICY_OWNER_NAME: getName(loggedUser.person),
      REPLACE_VIEW_BALANCE_PAID: "hidden",
      REPLACE_VIEW_AMOUNT: "show",
      REPLACE_POLICY_AMOUNT: stringFormattingToCurrency(
        ccQuotes.find(
          (creditCardquote) =>
            creditCardquote?.billingMode?.toLowerCase() ===
            getValues("billingmode")
        ).totalModalPremiumAmount
      ),
      REPLACE_POLICY_DATE: dateOfFrequency,
      REPLACE_POLICY_CARD_DETAILS: data?.cardNumber,
      REPLACE_VIEW_FREQUENCY: "show",
      REPLACE_POLICY_FREQUENCY: data?.billingmode,
    });
  };

  const checkedContinueIsDisabled = (billingMode, fourDigitCardNumber) => {
    if (ccQuotes?.length === 0 || cardNumbers?.length === 0) {
      setIsContinueDisabled(true);
      return;
    }
    let pProfile = paymentProfile?.find(
      (profile) =>
        profile?.paymentProfileId ===
        selectedPolicy?.creditCard?.recurringReferenceId
    );
    let accountNumber = selectedPolicy?.bankInfo?.bank?.accountNumber;

    let fourDigitAccountNumber = accountNumber?.substring(
      accountNumber.length - 4
    );

    if (
      fourDigitCardNumber === fourDigitAccountNumber &&
      billingMode === selectedPolicy?.billingMode?.toLowerCase()
    ) {
      setIsContinueDisabled(true);
      return;
    }

    if (toastDetail?.type === "error") {
      setIsContinueDisabled(true);
      return;
    }

    if (
      pProfile &&
      pProfile.cardNumber === fourDigitCardNumber &&
      billingMode === selectedPolicy?.billingMode?.toLowerCase()
    ) {
      setIsContinueDisabled(true);
      return;
    }
    setIsContinueDisabled(false);
  };

  const getBillingMode = (billingMode) => {
    switch (billingMode) {
      case "monthly":
        return "12";
      case "quarterly":
        return "04";
      case "semi-annual":
        return "02";
      case "annual":
        return "01";
    }
  };

  const UpdateFrequency = (consentNameEntered) => {
    setIsLoading(true);
    const payload = {
      policyId: selectedPolicy?.contractID,
      oldPolicyId: selectedPolicy?.oldPolicy,
      billingMode: getValues("billingmode"),
      userid: user?.userId,
      billingModeCode: getBillingMode(getValues("billingmode")),
      policyOwnerName: getName(loggedUser?.person),
      consentNameEntered: consentNameEntered,
    };
    //api call for update autopay
    UpdatePaymentFrequency(payload)
      .then((respone) => {
        setReferenceNumber(respone?.toUpperCase());
        setConfirmation("confirmation");
        setIsLoading(false);
        setToastDetail({
          type: "success",
          title: t("AuthCustomerEditPaymentFrequency-warningTitle"),
          message: t("AuthCustomerEditPaymentFrequency-warningMessage", {
            existingBillingMode: selectedPolicy?.billingMode,
            updatedBillingMode: getValues("billingmode"),
          }),
        });
        trackManageAutoPay({
          name: "Update Frequency",
          userId: user?.userId,
          userName: user?.userName,
          oldPolicyId: selectedPolicy?.oldPolicy,
          existingFrequency: selectedPolicy?.billingMode ?? "",
          changedFrequency: getValues("billingmode") ?? "",
          existingCreditCard: getExistingCreditCard() ?? "",
          changedCreditCard: getValues("cardNumber"),
        });
        //Send SMS Message
        if (config.COMPANY_NAME !== "everlake")
          sendSmsMessage(t("SMS-body"), config.SMS_TO_PHONE_NUMBER);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(
          "Server refused to connect, please try again later.",
          error
        );
        errorOccurred(
          t("AuthCustomerEditPaymentFrequency-updateAPIErrorTitle"),
          t("AuthCustomerEditPaymentFrequency-updateAPIErrorMessage")
        );
      });
  };

  const UpdateAutopay = (consentNameEntered) => {
    setAgrementState(false);
    if (csrUser?.userId) {
      //csr user can not save autopay
      setCsrUserState(true);
    } else {
      let pProfile = paymentProfile?.find(
        (profile) => profile.cardNumber === getValues("cardNumber")
      );
      if (!pProfile) UpdateFrequency(consentNameEntered);
      else {
        setIsLoading(true);
        const requestPayload = {
          paymentProfileId: pProfile?.paymentProfileId,
          policyId: selectedPolicy?.contractID,
          oldPolicyId: selectedPolicy?.oldPolicy,
          billingType: "06",
          billingMode: getBillingMode(getValues("billingmode")),
          billingModeCode: getValues("billingmode"),
          draftDay: moment(dateOfFrequency).format("DD"),
          userid: user?.userId,
          policyOwnerName: getName(loggedUser.person),
          policyPremium: ccQuotes.find(
            (creditCardquote) =>
              creditCardquote?.billingMode?.toLowerCase() ===
              getValues("billingmode")
          ).totalModalPremiumAmount,
          consentNameEntered: consentNameEntered,
          cardNumber: pProfile?.cardNumber,
          payDueAmount: false,
          pastDueAmount: "string",
          blockCode: selectedPolicy?.blockCode,
          isUpdateAutoPay: true,
        };
        //api call for update autopay
        setUpPolicyAutoPayApi(requestPayload)
          .then((respone) => {
            setReferenceNumber(respone?.toUpperCase());
            setConfirmation("confirmation");
            setIsLoading(false);
            setToastDetail({
              type: "success",
              title: t("AuthCustomerEditAutoPay-successTitle"),
              message: t("AuthCustomerEditAutoPay-successMessage"),
            });
            trackManageAutoPay({
              name: "Edit Autopay",
              userId: user?.userId,
              userName: user?.userName,
              oldPolicyId: selectedPolicy?.oldPolicy,
              existingFrequency: selectedPolicy?.billingMode ?? "",
              changedFrequency: getValues("billingmode") ?? "",
              existingCreditCard: getExistingCreditCard() ?? "",
              changedCreditCard: getValues("cardNumber"),
            });

            //Send SMS Message
            if (config.COMPANY_NAME !== "everlake")
              sendSmsMessage(t("SMS-body"), config.SMS_TO_PHONE_NUMBER);
          })
          .catch((error) => {
            setIsLoading(false);
            console.error(
              "Server refused to connect, please try again later.",
              error
            );
            errorOccurred(
              t("AuthCustomerEditAutoPay-errorTitle"),
              t("AuthCustomerEditAutoPay-errorMessage")
            );
          });
      }
    }
  };

  return (
    <>
      <EverlakeLoadingOverlay isLoading={isLoading}>
        {toastDetail?.type && (
          <Toast
            title={toastDetail.title}
            message={toastDetail.message}
            type={toastDetail.type}
          />
        )}
        <div className="container mb-8">
          <h1>
            {confirmation === "confirmation"
              ? t("AuthCustomerAutoPaySummary-title")
              : t("AuthCustomerManageAutoPay-title")}
          </h1>
          <hr />
        </div>
        <div className="container mt-8">
          <p>
            {getPolicyType(selectedPolicy)} Policy #{selectedPolicy?.oldPolicy}
          </p>
        </div>

        <div className="container ui-component-spacing mt-8">
          <div className="w-full">
            {confirmation !== "confirmation" ? (
              <>
                <form onSubmit={handleSubmit(openAgrementForm)}>
                  <div className="ui-card relative mb-4 md:mb-6">
                    <div className="mt-2 grid grid-cols-5 p-6 gap-2">
                      <h3>{t("CustomerEditManageAutoPay-frequency")}</h3>
                      <div className="col-span-4">
                        <fieldset className="flex flex-col gap-1">
                          {frequency.map((option) => (
                            <div key={option.title}>
                              <label
                                className={`inline-flex items-center text-sm ${
                                  selectedPolicy?.billingMode.toLowerCase() !==
                                  option.value
                                    ? "font-normal"
                                    : undefined
                                }`}
                              >
                                <input
                                  type="radio"
                                  className="mr-2"
                                  value={option.value}
                                  {...register("billingmode")}
                                  onChange={(e) => {
                                    checkedContinueIsDisabled(
                                      e.target.value,
                                      getValues("cardNumber")
                                    );
                                    setNextPayment(
                                      getNextPaymentDate(
                                        e.target.value,
                                        getAutopayFrequencyDate(
                                          selectedPolicy,
                                          e.target.value
                                        )
                                      )
                                    );
                                    setDateOfFrequency(
                                      getAutopayFrequencyDate(
                                        selectedPolicy,
                                        e.target.value
                                      )
                                    );
                                  }}
                                />
                                {option.title}
                              </label>
                            </div>
                          ))}
                        </fieldset>
                      </div>

                      <hr className="col-span-5" />

                      <h3 className="flex items-center">
                        {t("CustomerEditManageAutoPay-method")}
                        {showTooltip && (
                          <Tooltip
                            xMargin="mx-0"
                            content={`Autopay was set up with ${convertToTitleCase(
                              party?.cardHolderName
                            )}'s credit card and won't appear in your payment methods.`}
                          />
                        )}
                      </h3>
                      <div className="ui-form-make-payment col-span-3">
                        {cardNumbers?.length > 0 && (
                          <RadioGroup
                            className="grid grid-cols-1 lg:grid-cols-3"
                            aria-label="Select autopay method"
                            value={selected}
                            {...register("cardNumber")}
                            onChange={(value) => {
                              setSelected(value);
                              setValue("cardNumber", value);
                              checkedContinueIsDisabled(
                                getValues("billingmode"),
                                value
                              );
                            }}
                          >
                            {cardNumbers.map((card) => {
                              return (
                                <RadioGroup.Option
                                  key={card}
                                  className={({ checked }) =>
                                    `ui-form-card cursor-pointer font-semibold ${
                                      checked ? "selected" : ""
                                    }`
                                  }
                                  value={card}
                                >
                                  <RadioGroup.Label as="label">
                                    <span className="block text-xxs mb-2 font-normal">
                                      {
                                        getAutoPayDescriptions(
                                          selectedPolicy,
                                          card
                                        )[0]
                                      }
                                    </span>
                                    <span className="block text-base mb-5">
                                      {
                                        getAutoPayDescriptions(
                                          selectedPolicy,
                                          card
                                        )[1]
                                      }{" "}
                                      Ending in {card}
                                    </span>
                                  </RadioGroup.Label>
                                  <div className="ui-form-card-checkbox">
                                    <svg
                                      className="ui-icon w-2 h-2 text-white hidden"
                                      focusable="false"
                                      aria-hidden="true"
                                      role="presentation"
                                    >
                                      <use href="#ui-icon-checkmark"></use>
                                    </svg>
                                  </div>
                                </RadioGroup.Option>
                              );
                            })}
                          </RadioGroup>
                        )}
                      </div>
                      <div className="text-sm md:justify-self-end pt-2">
                        <button
                          type="button"
                          className="ui-btn-hyperlink"
                          aria-label="Edit manage auto pay"
                          onClick={() => setModalState(true)}
                        >
                          {t("CustomerEditManageAutoPay-add-method")}
                        </button>
                      </div>

                      <hr className="col-span-5" />

                      <h3>{t("CustomerEditManageAutoPay-date")}</h3>
                      <div className="col-span-4">
                        <p className="font-bold">{nextPayment}</p>
                        {!nextPayment?.includes("day of every month") && (
                          <p className="text-xs">
                            {t("CustomerEditManageAutoPay-next-payment-date")}
                          </p>
                        )}
                        <p className="text-xs">
                          {getDraftDayDisclaimer(
                            moment(dateOfFrequency).format("DD")
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <button
                      type="button"
                      className="ui-btn-secondary"
                      aria-label="Back to manage auto pay"
                      onClick={() => setManageAutoPayMode("view")}
                    >
                      {t("CustomerEditManageAutoPay-back")}
                    </button>
                    <button
                      className="ui-btn-primary"
                      aria-label="Continue auto pay"
                      disabled={isContinueDisabled}
                    >
                      {t("CustomerEditManageAutoPay-continue")}
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <>
                <div className="ui-card relative mb-4 md:mb-6">
                  <div className="mt-2 grid grid-cols-[1fr,2fr,1fr] gap-2 px-6 py-6">
                    <h3>{t("CustomerEditManageAutoPay-frequency")}</h3>
                    <div className="col-span-4">
                      <p className="font-bold">
                        {convertToTitleCase(getValues("billingmode"))}
                      </p>
                      <div>
                        {stringFormattingToCurrency(
                          ccQuotes.find(
                            (ccQuote) =>
                              ccQuote.billingMode?.toLowerCase() ===
                              getValues("billingmode")
                          )?.totalModalPremiumAmount
                        )}
                      </div>
                    </div>
                    <hr className="col-span-5" />
                    {getValues("cardNumber") && (
                      <>
                        <h3>{t("CustomerEditManageAutoPay-method")}</h3>
                        <div className="ui-form-make-payment col-span-3">
                          <p className="font-bold">
                            {
                              getAutoPayDescriptions(
                                selectedPolicy,
                                getValues("cardNumber")
                              )[1]
                            }{" "}
                            Ending in {getValues("cardNumber")}
                          </p>
                        </div>
                        <hr className="col-span-5" />
                      </>
                    )}
                    <h3>{t("CustomerEditManageAutoPay-date")}</h3>
                    <div className="col-spoan-4">
                      <p className="font-bold">{nextPayment}</p>
                      {!nextPayment?.includes("day of every month") && (
                        <p className="text-xs">
                          {t("CustomerEditManageAutoPay-next-payment-date")}
                        </p>
                      )}
                      <p className="text-xs">
                        {getDraftDayDisclaimer(
                          moment(dateOfFrequency).format("DD")
                        )}
                      </p>
                    </div>
                    <hr className="col-span-5" />
                    <div className="col-span-5">
                      <h3>
                        {`Autopay was initiated on ${moment().format(
                          "MM/DD/YYYY"
                        )}. The transaction
                        reference number is: ${referenceNumber}`}
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="mt-1 md:mt-2 pb-4">
                    <button
                      className="ui-btn-hyperlink"
                      aria-label="Close manage auto pay"
                      onClick={() => navigate("/payment")}
                    >
                      {t("CustomerEditManageAutoPay-confirmation-back")}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </EverlakeLoadingOverlay>
      <AddPaymentMethod
        modalState={modalState}
        setModalState={setModalState}
        selectedPolicy={selectedPolicy}
        setToastDetail={setToastDetail}
        portalReturnURL={`/payment/manageautopay/${selectedPolicy?.contractID}`}
      />
      <GeneralPurposeDialog
        title={t("CSRErrorMessage-title")}
        desc={t("CSRErrorMessage-message")}
        state={csrUserState}
        setState={setCsrUserState}
        showCloseButton={false}
      />
      <PaymentDialog
        showPaymentDialog={agrementState}
        setShowPaymentDialog={setAgrementState}
        data={data}
        action={(inputValue) => UpdateAutopay(inputValue)}
      />
    </>
  );
}
